import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '../../components/Button/Button';
import { useQueryParams } from '../../hooks/useQueryParams';
import { useLanguage } from '../../locale/useLanguage';
import { Routes } from '../../routes/types';
import cartErrorImage from '../../assets/images/cart-error.png';

import './PaymentErrorView.css';
import { CallbackTranslation } from '../../locale/localizationContext';

enum PaymentError {
  GenericError = 'GENERIC_ERROR',
  UnexpectedError = 'UNEXPECTED_ERROR',
  DuplicateId = 'DUPLICATE_ID',
  GatewayError = 'GATEWAY_ERROR',
  WrongCardNumber = 'WRONG_CARD_NUMBER',
  FraudCheckFailed = 'FRAUD_CHECK_FAILED',
  ReachedMaxAttempts = 'REACED_MAX_ATTEMPTS',
}

type PaymentErrorViewProps = {};

export const PaymentErrorView: React.FC<PaymentErrorViewProps> = () => {
  const [t] = useLanguage();
  const history = useHistory();
  const queryParams = useQueryParams();
  const errorCode: PaymentError = queryParams.get('errorCode') as PaymentError;
  const errorDescription = getErrorDescription(errorCode, t);

  useEffect(() => {
    if (!errorCode) {
      history.replace(Routes.Home);
    }
  }, [history, errorCode]);

  const goToPaymentMethods = useCallback(() => {
    history.replace(Routes.PaymentMethod);
  }, [history]);

  return (
    <div className="payment-error--container">
      <div className="payment-error--body">
        <div className="payment-error--content">
          <img className="payment-error--image" src={cartErrorImage} />
          <h3>{t('paymentError.title')}</h3>
          <p className="payment-error--description">
            {t('paymentError.description')}
          </p>
          <p className="payment-error--description payment-error--error-code">
            {t('paymentError.causeTitle')}
          </p>
          <p className="payment-error--description">{errorDescription}</p>
        </div>
        <div>
          <Button
            onClick={goToPaymentMethods}
            isWhite
            label={t('paymentError.editPaymentMethod')}
          />
        </div>
      </div>
    </div>
  );
};

const getErrorDescription = (
  errorCode: PaymentError,
  t: CallbackTranslation
) => {
  switch (errorCode) {
    case PaymentError.DuplicateId:
      return t('paymentError.duplicateId');
    case PaymentError.FraudCheckFailed:
      return t('paymentError.fraudCheckFailed');
    case PaymentError.GatewayError:
      return t('paymentError.gatewayError');
    case PaymentError.ReachedMaxAttempts:
      return t('paymentError.reachedMaxAttempts');
    case PaymentError.GenericError:
      return t('paymentError.genericError');
    case PaymentError.WrongCardNumber:
      return t('paymentError.wrongCardNumber');
    default:
      return t('paymentError.unexpectedError');
  }
};
